import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	listContainer: {
		flex               : "1",
		height             : "inherit",
		overscrollBehavior : "contain",
		overflow           : "hidden auto",
		backgroundColor    : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryWhite,

		[rooterMediaQuery.mobile]: {
			height: "calc(100% - 100px)"
		}
	},
	itemContainer: {
		display    : "flex",
		alignItems : "center",
		padding    : "0.8rem 1rem"
	},
	avatarContainer : { flex: 0 },
	avatar          : { ...theme.other.rooterAvatars.size40 },
	img             : {
		...theme.other.responsiveImage,
		...theme.other.rooterAvatars.borderRadius
	},
	itemSectionRightContainer: {
		marginLeft : "1rem",
		flex       : "1"
	},
	nameTopContainer: {
		display        : "flex",
		justifyContent : "space-between",
		alignItems     : "center"
	},
	svgIcon: {
		...theme.other.svgIcons.size25,
		cursor: "pointer"
	},
	followIconStyles: {
		transform : "scale(0.6)",
		cursor    : "pointer"
	},
	nameText: {
		flex       : "1 1 auto",
		fontSize   : "1.4rem",
		fontWeight : "normal",
		color      : theme.other.colors.text.primary
	},
	followButton: {
		flex       : "0 0 auto",
		marginLeft : "2rem"
	},
	emptyStateContainer: {
		height         : "100%",
		display        : "flex",
		flexDirection  : "column",
		justifyContent : "center",
		alignItems     : "center"
	},
	separator: {
		borderTop : `1px solid ${ theme.other.colors.border.primary }`,
		width     : "90%",
		position  : "relative",
		left      : "14%"
	},
	emotes: {
		width  : "20px",
		height : "20px",
		margin : "0 2px"
	},
	parent: {
		overflowX      : "hidden",
		overflowY      : "auto",
		display        : "flex",
		flexDirection  : "column-reverse",
		justifyContent : "flex-start",
		paddingTop     : "0px"
	},
	nameAndCommentContainer: {
		padding      : "0.5rem 1rem",
		display      : "flex",
		fontSize     : "1.2rem",
		paddingRight : "1rem",

		"& .optionsButtonInChat": {
			display: props?.isPopUpOpen ? "block" : "none"
		},

		"&:hover": {
			backgroundColor          : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
			"& .optionsButtonInChat" : {
				display: "block"
			}
		}
	},
	avatarImage: {
		height       : "2.5rem",
		width        : "2.5rem",
		borderRadius : "100%",
		objectFit    : "cover",
		cursor       : "pointer"
	},
	anchorTag: {
		all: "unset"
	},
	nameAnchorTag: {
		all       : "unset",
		cursor    : "pointer",
		"&:hover" : {
			textDecoration: "underline"
		}
	},
	svgVerifiedIcon: {
		width        : "1.75rem",
		height       : "1.75rem",
		marginLeft   : "0.5rem",
		marginBottom : "0.5rem"

	},
	userName: {
		color       : theme.other.colors.text.secondary,
		fontSize    : "1.4rem",
		fontWeight  : "500",
		display     : "inline-flex",
		alignItems  : "center",
		marginRight : "0.5rem"

	},
	userNameAndCommentInChat: {
		padding    : "0px 0.8rem",
		alignItems : "center",
		marginTop  : "0.1rem"
	},
	commentText: {
		color      : theme.other.colors.text.primary,
		display    : "inline",
		wordBreak  : "break-word",
		fontWeight : 500,
		fontSize   : "1.4rem"
	},
	chatEmptyIcon: {
		width: "10rem"
	},
	emoteContainer: {
		width         : "20px",
		display       : "inline-flex",
		marginTop     : "-0.6rem",
		verticalAlign : "-webkit-baseline-middle"
	}
} ) );
